import BeamElement from "./element.js";

export default class AppliedMoment extends BeamElement{
    constructor(type, location, magnitude) {
        super(type);
        this.location = location;
        this. magnitude = magnitude; 
    }
} 